export default function api_auth(
  state = {
    token: localStorage.getItem("token"),
    isAuthenticated: false,
    user: null,
  },
  action
) {
  switch (action.type) {
    case "FETCH_AUTHUSER_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        user: action.response.data,
      };

    case "REGISTER_SUCCESS":
    case "LOGIN_SUCCESS":
      localStorage.setItem("token", action.response.data.token);
      return {
        ...state,
        ...action.response.data,
        isAuthenticated: true,
      };

    case "LOGOUT_SUCCESS":
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
      };

    case "LOGIN_FAILURE":
    case "REGISTER_FAILURE":
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
      };

    case "FETCH_AUTHUSER_FAILURE":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    default:
      return state;
  }
}
